export const columns = function () {
  // {
  //     "id": "主键id",
  //     "bh": "单号",
  //     "insBillId": "流水单号",
  //     "carNo": "车牌号",
  //     "beginTime": "服务起期",
  //     "endTime": "暂停结束时间",
  //     "carType": "车型",
  //     "startTime": "暂停开始时间",
  //     "realname": "创建人",
  //     "create_time": "创建时间"
  // }
  return [
    {
      prop: "insBillId",
      label: "服务单流水号",
      fixed: "left",
      minWidth: 80,
    },
    {
      prop: "bh",
      label: "单号",
      minWidth: 100,
    },
	{
	  prop: "orgName",
	  label: "出单机构",
	  minWidth: 50,
	},
    {
      prop: "carNo",
      label: "车牌号",
      minWidth: 80,
    },
    {
      prop: "carType",
      label: "车型",
      minWidth: 100,
    },

    {
      prop: "beginTime",
      label: "服务起期",
      minWidth: 100,
    },
	{
	  prop: "billEndTime",
	  label: "服务止期",
	  minWidth: 100,
	},
    {
      prop: "startTime",
      label: "暂停开始时间",
      minWidth: 100,
    },
	{
	  prop: "endTime",
	  label: "暂停结束时间",
	  minWidth: 100,
	},
	{
	  prop: "realname",
	  label: "创建人",
	  minWidth: 50,
	},
	{
	  prop: "create_time",
	  label: "创建时间",
	  minWidth: 100,
	},
    {
      prop: "handle",
      label: "操作",
      minWidth: 150,
      fixed: "right",
    },
  ];
};

export const agreementColumns = function () {
  return [
    {
      prop: "tyName",
      label: "特约名称",
    },
    {
      prop: "tyContent",
      label: "特约内容",
    },
    {
      prop: "handle",
      label: "操作",
      width: 150,
    },
  ];
};

export default {};
